import { Icon, InputWithIcon } from '@livable/saas-react-components';
import { Alert, TextField, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import TenantsListSelector from 'src/components/property/TenantsListSelector';
import useStyles from '../styles';
export default function ResidentsTab(_ref) {
  let _ref$tenantsList = _ref.tenantsList,
    tenantsList = _ref$tenantsList === void 0 ? undefined : _ref$tenantsList,
    _ref$buildingsList = _ref.buildingsList,
    buildingsList = _ref$buildingsList === void 0 ? undefined : _ref$buildingsList;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, buildingsList && /*#__PURE__*/React.createElement(Alert, {
    severity: "info",
    icon: false,
    onClose: () => {},
    size: "small",
    variant: "modal"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('post_charge_modal.tip_title')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('post_charge_modal.tip_text'))), /*#__PURE__*/React.createElement("div", {
    className: buildingsList ? classes.lgSection : ''
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('post_charge_modal.select_who_to_post', {
    count: 0
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(InputWithIcon, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "search"
    })
  }, /*#__PURE__*/React.createElement(TextField, {
    id: "input-with-icon",
    label: t('post_charge_modal.search_list'),
    variant: "outlined",
    fullWidth: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, buildingsList && /*#__PURE__*/React.createElement(React.Fragment, null, buildingsList.map(building => /*#__PURE__*/React.createElement(TenantsListSelector, {
    key: building.address,
    type: "building",
    title: building.address,
    list: building.tenants
  }))), tenantsList && /*#__PURE__*/React.createElement(TenantsListSelector, {
    title: t('post_charge_modal.select_all_residents'),
    list: tenantsList
  })));
}
ResidentsTab.propTypes = {
  tenantsList: PropTypes.arrayOf(PropTypes.string),
  buildingsList: PropTypes.arrayOf(PropTypes.shape({
    address: PropTypes.string,
    tenants: PropTypes.arrayOf(PropTypes.string)
  }))
};